// GM Director Spotlight websocket bridge. Rendering stays inside the same-origin FT3D scene iframe;
// the websocket bundle only validates the small encounter-scoped envelope and raises a DOM event.

import type { WSMessage } from './types';

type SpotlightUpdate = Extract<WSMessage, { type: 'ft3d_director_spotlight_update' }>;
type SpotlightClear = Extract<WSMessage, { type: 'ft3d_director_spotlight_clear' }>;

function validBase(data: SpotlightUpdate | SpotlightClear): boolean {
    return data.schema === 'ft.ft3d.director-spotlight.v1'
        && checkIfValidUUID(data.encounter_id)
        && checkIfValidUUID(data.spotlight_id)
        && Number.isSafeInteger(Number(data.sequence))
        && Number(data.sequence) >= 0;
}

function handleFt3dDirectorSpotlightUpdate(data: SpotlightUpdate): void {
    if (!validBase(data)) return;
    const numbers = [data.x, data.y, data.z, data.radius_ft].map(Number);
    if (!numbers.every(Number.isFinite) || numbers[3]! < 0.5 || numbers[3]! > 60) return;
    window.dispatchEvent(new CustomEvent('ft:ft3d-director-spotlight', { detail: data }));
}

function handleFt3dDirectorSpotlightClear(data: SpotlightClear): void {
    if (!validBase(data)) return;
    window.dispatchEvent(new CustomEvent('ft:ft3d-director-spotlight', { detail: data }));
}

window.handleFt3dDirectorSpotlightUpdate = handleFt3dDirectorSpotlightUpdate;
window.handleFt3dDirectorSpotlightClear = handleFt3dDirectorSpotlightClear;

export { handleFt3dDirectorSpotlightUpdate, handleFt3dDirectorSpotlightClear };
